<template>
    <div class="col-12">
        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-10 col-lg-6">
                <div class="row text-center ml-5">
                    <div class="mb-5">
                        <img src="../../assets/tn_cybertech_grad_logo.png" class="tn-logo" style="width: 200px; height: auto;">
                    </div>
                    <h3 class="ui inverted purple text">
                        <strong>{{ view === 'accountType' ? 'Select Account Type' : 'Select Currency' }}</strong>
                    </h3>
                    <p class="text-muted mt-4">
                        {{ view === 'accountType'
                            ? 'Choose the type of account that best suits your needs.'
                            : 'Select your preferred currency for this account.' }}
                    </p>
                </div>
                <div class="ui fitted divider mt-2"></div>
            </div>
        </div>

        <div v-if="view === 'accountType'" class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-11 col-lg-10">
                <div class="row mb-5">
                    <div class="col-12 col-md-6 col-lg-4 mb-3" v-for="account in accountTypes" :key="account.id">
                        <div class="card card-shadow border-purple h-100">
                            <div class="card-body d-flex flex-column">
                                <h4 class="card-title"><strong>{{ account.name }}</strong></h4>
                                <p class="card-text text-muted fw-light">
                                    <span v-if="account.showFullDescription">{{ account.description }}</span>
                                    <span v-else>
                                        <span class="description-ellipsis">{{ account.description }}</span>
                                        <a href="#" @click.prevent="toggleDescription(account)">Read more</a>
                                    </span>
                                </p>
                                <div class="mt-auto pt-3">
                                    <button class="ui purple large basic right floated button" @click="selectAccount(account)">
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-5">
                    <button @click="back" class="ui grey large basic button fluid">Back</button>
                </div>
            </div>
        </div>

        <div v-if="view === 'currencyType'" class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-11 col-lg-10">
                <div class="row mb-5">
                    <template v-if="selectedAccount.currency === 'ALL'">
                        <div class="col-12 col-md-4 mb-3" v-for="currency in currencies" :key="currency.type">
                            <div class="card card-shadow border-dark h-100">
                                <div class="card-body d-flex flex-column">
                                    <h4 class="card-title"><strong>{{ currency.type }}</strong></h4>
                                    <p class="card-text text-muted fw-light">{{ currency.description }}</p>
                                    <div class="mt-auto pt-3">
                                        <button class="ui purple large basic right floated button" @click="selectCurrency(currency.type)">
                                            Select
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col-12 col-md-4 mb-3">
                            <div class="card card-shadow border-dark h-100">
                                <div class="card-body d-flex flex-column">
                                    <h4 class="card-title"><strong>{{ selectedAccount.currency }}</strong></h4>
                                    <p class="card-text text-muted fw-light">{{ currencyDescriptions[selectedAccount.currency] }}</p>
                                    <div class="mt-auto pt-3">
                                        <button class="ui purple large basic right floated button" @click="selectCurrency(selectedAccount.currency)">
                                            Select
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="mt-5">
                    <button @click="view = 'accountType'" class="ui grey large basic button fluid">Back</button>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import baseMethods from "@/utils/baseMethods";
import { useAccountOpeningStore } from '@/stores/accountOpening';

export default {
    name: "AccountType",
    setup() {
        const accountOpeningStore = useAccountOpeningStore();
        return { accountOpeningStore };
    },
    data() {
        return {
            view: 'accountType', // To manage view state
            accountTypes: [],
            selectedAccount: null, // To store selected account,
            currencies: [
                { type: 'USD', description: 'United States Dollar' },
                { type: 'ZiG', description: 'Zimbabwean Dollar' },
                { type: 'BOTH', description: 'Both USD and ZiG' }
            ],
            currencyDescriptions: {
                'USD': 'United States Dollar',
                'ZiG': 'Zimbabwean Dollar'
            }
        };
    },
    mounted() {
        this.getAccountTypes();
    },
    methods: {
        openAccount(account) {
            this.setAccountType(account.accountType);
            if (account.accountType !== "ISAVE") {
                this.$router.push("/omni/signature");
            }
        },
        async getAccountTypes() {
            try {
                const res = await this.getNoAuthAndNoBaseUrl('/account-opening/accounts-types/all',
                    "Account Types Collected Successfully", null, true);
                this.accountTypes = res.body.map(account => ({
                    ...account,
                    showFullDescription: false
                }));
            } catch (error) {
                // Error handled silently
            }
        },
        toggleDescription(account) {
            account.showFullDescription = !account.showFullDescription;
        },
        selectAccount(account) {
            this.selectedAccount = account;
            this.view = 'currencyType';
        },
        selectCurrency(currency) {
            // Save account and currency selection to Vuex
            this.selectAccountAndCurrency({
                accountType: this.selectedAccount.accountType,
                preAccountType: this.selectedAccount.preAccountType,
                currencyType: currency,
            });
            this.$router.push("/omni/signature");
        },
        back() {
            this.$router.push("/omni/terms-and-conditions");
        },
        setAccountType(type) { this.accountOpeningStore.setAccountType(type); },
        selectAccountAndCurrency(data) { this.accountOpeningStore.selectAccountAndCurrency(data); },
        ...baseMethods,
    }
};
</script>

<style scoped>
.description-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}
</style>
